import React from 'react';
// import BanneCourses from './main/BannerCourses';
import CoursesBackg from './ui/CoursesBackg';

import InduCourse from './ui/InduCourse';
import Orb from "./main/Orb";



const CoursesPage = () => {
  return (<>
  {/* <div className="courseSection"><div className="background">

<div style={{ width: '100%', height: 600, position: 'relative' }}>
  <CoursesBackg
    colors={[ '#5227FF', '#FF9FFC', '#B19EEF' ]}
    mouseForce={20}
    cursorSize={100}
    isViscous={false}
    viscous={30}
    iterationsViscous={32}
    iterationsPoisson={32}
    resolution={0.5}
    isBounce={false}
    autoDemo={true}
    autoSpeed={0.5}
    autoIntensity={2.2}
    takeoverDuration={0.25}
    autoResumeDelay={3000}
    autoRampDuration={0.6}
  />
</div>
 
</div>
  </div> */}
    <div className="cyber-banner-container">
          <div className="orb-background">
            <Orb />
          </div>
  <InduCourse/>
          <div className="cyber-banner-left">
            <h1 id="textfont">
              {/* <BlurText
                text="Wellcome  TO"
              
                delay={120}
                animateBy="words"
                direction="top"
                className="text-heading"
              />
              <br />
              <BlurText
                text="Hacker's  World"
                delay={120}
                animateBy="words"
                direction="top"
                className="text-subheading" */}
              
               {/* <RollingGallery
    text= "Wellcome To"
    enableWaves={true}
    asciiFontSize={8}
    
  /><br/>
  
            <RollingGallery
    text= "Hacker's  World"
    enableWaves={true}
    asciiFontSize={8}
    
  /> */}
            </h1>
            {/* <p>Please Contact to be a part of the event.</p> */}
  
            {/* WhatsApp Direct Link */}
            {/* <a
              href="https://wa.me/8120851906?text=Hi!%20I%20want%20to%20register%20for%20CyberSec%20Connect."
              target="_blank"
              rel="noopener noreferrer"
            >
              <button>Contact Now</button>
            </a> */}
          </div>
  
          {/* <div className="cyber-banner-right">
            <div className="cyber-image-circle">
              <img src={Hackerbenner} alt="Cybersecurity Expert" />
            </div>
          </div> */}
           
        </div>
        {/* <FixedImageWithToggleArrows /> */}
      

  </>);
};

export default CoursesPage;